module.exports = require('./helpers/bundle-url').getBundleURL('6EXJA') + "Work.353f9002.svg" + "?" + Date.now();